<template>
  <svg width="35" height="35" viewBox="0 0 97 97" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.54558 3.01497e-10L0 2.54558L93.4795 96.0251L96.0251 93.4795L2.54558 3.01497e-10Z" fill="#42410b" />
    <path d="M93.4795 2.40248e-06L0 93.4795L2.54558 96.0251L96.0251 2.54559L93.4795 2.40248e-06Z" fill="#42410b" />
  </svg>
</template>
